export default __webpack_public_path__ + "locales/sq-AL/Errors.json?hash=d822eece681bf21362bf55fc769faa2e";